export type Layout = 'list' | 'thumbnail'

export enum EnvironmentDeploy {
  Stage = 'stage',
  Testnet = 'testnet',
  Mainnet = 'mainnet'
}
